import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import PublishStatusTableRow from '../table/PublishStatusTableRow.js';

class EquipmentLevelList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideArchived: true
    };
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    return (
      <div>
        <div className="pull-right">
          <Link
            to={`/equipmentlevel/new/${this.props.modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til utstyrsnivå
          </Link>
          &nbsp;
          <button onClick={(e) => {
            e.preventDefault();
            this.toggleShowArchived();
          }} className="btn btn-info" disabled={this.state.working}>
            {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
          </button>
        </div>
        <div className="table-responsive clearboth">
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th title="Publiseringsstatus"></th>
                <th>Navn</th>
                <th>Visningsnavn</th>
                <th>Nivå</th>
              </tr>
            </thead>
            <tbody>
              {this.props.equipmentLevels.map((level) => {
                if (this.state.hideArchived && level.archived) {
                  return;
                }
                return (
                  <PublishStatusTableRow entry={level} key={level.id}>
                    <td className="text-center">
                      <PublishStatusDot entry={level} />
                    </td>
                    <td><Link to={`/equipmentlevel/${level.id}`}>{level.name}</Link></td>
                    <td>{level.displayname}</td>
                    <td>{level.equipmentLevel}</td>
                  </PublishStatusTableRow>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default EquipmentLevelList;
